import EditorWrapper from "../ui/EditorWrapper";
import CommitData from "../../models/interactions/commit/CommitData";
import useHttp from "../../hooks/useHttp";
import { useState } from "react";
import { navSliceActions } from "../../store/slices/NavSlice";
import { useStoreDispatch } from "../../store/Hooks";
import CommitSection from "./CommitSection";

interface CommitProps {
  commitData: CommitData;
}

const CommitTool = (props: CommitProps) => {
  const { sendRequest: fetchData } = useHttp();
  const dispatch = useStoreDispatch();

  /* ******** LOGIC FOR HANDLING UN-SELECTED ID CHECKBOXES ********* */
  // represents the "unchecked" boxes for interactions we do NOT want to commit
  const [interactionsToCommitOmit, setInteractionsToCommitOmit] = useState<Array<number>>([])
  const [intervalSetsToCommitOmit, setIntervalSetsToCommitOmit] = useState<Array<number>>([])
  const [intervalsToCommitOmit, setIntervalsToCommitOmit] = useState<Array<number>>([])
  const [communicationsToCommitOmit, setCommunicationsToCommitOmit] = useState<Array<number>>([])

  const handleChange = (id:number, checked:boolean, type: string) => {
    if(type === 'interaction'){
      let interactionsToCommitOmitCopy = [...interactionsToCommitOmit];
      if(!checked){
        interactionsToCommitOmitCopy.push(id)
      } else {
        interactionsToCommitOmitCopy = interactionsToCommitOmitCopy.filter(item => item !== id);
      }
      setInteractionsToCommitOmit(interactionsToCommitOmitCopy)
    } else if (type === "interval_set"){
      let intervalSetsToCommitOmitCopy = [...intervalSetsToCommitOmit];
      if(!checked){
        intervalSetsToCommitOmitCopy.push(id)
      } else {
        intervalSetsToCommitOmitCopy = intervalSetsToCommitOmitCopy.filter(item => item !== id);
      }
      setIntervalSetsToCommitOmit(intervalSetsToCommitOmitCopy)
    } else if (type === "interval"){
      let intervalsToCommitOmitCopy = [...intervalsToCommitOmit];
      if(!checked){
        intervalsToCommitOmitCopy.push(id)
      } else {
        intervalsToCommitOmitCopy = intervalsToCommitOmitCopy.filter(item => item !== id);
      }
      setIntervalsToCommitOmit(intervalsToCommitOmitCopy)
    } else if (type === "communication_set"){
      let communicationsToCommitOmitCopy = [...communicationsToCommitOmit];
      if(!checked){
        communicationsToCommitOmitCopy.push(id)
      } else {
        communicationsToCommitOmitCopy = communicationsToCommitOmitCopy.filter(item => item !== id);
      }

      setCommunicationsToCommitOmit(communicationsToCommitOmitCopy)
    }

  };
  
  return (
    <EditorWrapper
      leaveDrawerOpenOnAction={true}
      commit={async ()=>{
        dispatch(
          navSliceActions.openModal({
              caresenseModalAlertType: "commit",
              caresenseModalAlertMessage:  "This action will commit and deploy the selected interaction(s) to the live application. Proceed?",
              caresenseModalAlertEntityID: null,
              modalCallback: async ()=>{ // post callback to redux so modal alert calls it on user approval
                    await props.commitData.commit(
                      interactionsToCommitOmit,
                      intervalSetsToCommitOmit,
                      intervalsToCommitOmit,
                      communicationsToCommitOmit);
                      
                    setInteractionsToCommitOmit([])
                    setIntervalSetsToCommitOmit([])
                    setIntervalsToCommitOmit([])
                    setCommunicationsToCommitOmit([])
              } 
          }),
      );
        }
      }
      title={"Commit and Publish Interactions"}
      inDrawer={true}
    >
      <CommitSection commitData={props.commitData} type={"interactions"} handleChange={handleChange} />
      <CommitSection commitData={props.commitData} type={"interval_sets"} handleChange={handleChange} />
      <CommitSection commitData={props.commitData} type={"intervals"} handleChange={handleChange} />
      <CommitSection commitData={props.commitData} type={"communication_sets"} handleChange={handleChange} />

    </EditorWrapper>
  );
};

export default CommitTool;
